import { GuaranteedEntity, OrderStatus } from "./order"

export interface Bot {
    id: number,
    steamId: bigint,
    userName: string,
    isDisabled: boolean,
    proxyId?: number,
    proxyAddress?: string,
    mode: BotMode,
    level: number,
    bannedAt?: Date,
    comment: string,
    nickName?: string,
    avatar?: string
}

export interface BotsListRequest{
    search?: string,
    mode?: BotMode[],
    isDisabled?: boolean,
    isBanned?: boolean,
    proxy?: number,
    page: number,
    count: number
}

export interface BotsListResult{
    items:Bot[],
    count:number,
}

export interface FullBotInfo extends Bot{
    password: string,
    mobileAuthData: string,
    apiKey: string,
    tradeLink?: string,
    osType?: number,
    gamesInventoriesSize?: BotGameInfo[]
}

export interface BotGameInfo {
    gameId: number,
    size: number
}

export const BotModeDescription = {
    0: 'Обработка сделок через бота-посредника',
    1: 'Обработка P2P сделок',
    4: 'Обновление данных по скинам (CS- float, pattern)',
    5: 'Загрузка пользовательских инвентарей',
    6: 'Валидация торговых ссылок и возможности торговли между пользователями',
}

export const BotModeName = {
    0: 'Обмен через ботов',
    1: 'P2P',
    4: 'Скины',
    5: 'Загрузка инв.',
    6: 'Валидация сделок',
}

export enum BotMode {
    TF2 = 0,
    P2P = 1,
    SkinsDataLoader = 4,
    InventoryLoad = 5,
    Validation = 6
}

export interface BotSkinInfo {
    assetId: number,
    created?: Date,
    sourceOrderId?: number,
    sourceOrderStatus?: OrderStatus,
    gameId: number,
    hashName: number,
    image?: string,
    canTrade?: boolean
}

export class BotTransferRequest {
    public botId: number;
    public gameId: number;
    public tradeLink: string;
    public dateBefore?: Date;
    public assetIds?: number[];
    public orderId?: number;

    constructor(botId: number, gameId: number, tradeLink: string, dateBefore?: Date, assetIds?: number[], orderId?: number) {
        this.botId = botId;
        this.gameId = gameId;
        this.tradeLink = tradeLink;
        this.dateBefore = dateBefore;
        this.assetIds = assetIds;
        this.orderId = orderId;
    }
}

export interface BotTransferResult {
    botId: number,
    success: boolean,
    errorMessage?: string,
    steamOfferId?: number
}

export interface BotState {
    id: number,
    isStarted: boolean,
    isRunning: boolean,
    isBusy: boolean,
    stopReason?: string,
    offersQueueSize: number,
    /** Запросов на загрузку инвентаря за период из серверных настроек. Не задано — бот не загружает инвентарь */
    inventoryLoadRequestsCount?: number,
    /** Время (UTC), до которого бот не выбирается для загрузки инвентаря из-за 429 от Steam. Не задано — ограничения нет */
    inventoryLoadTooManyRequestsUntil?: Date
}

export interface BotOrder extends GuaranteedEntity {
    orderId: number,
    orderStatus: OrderStatus,
    sellerId: bigint,
    buyerId: bigint,
    totalAmountIncludingFee: number,
    totalFee: number
}

export interface BotStatsInfo {
    statsDataPoints: BotStatsDataPoint[],
    totalSuccesses: number,
    totalFailures: number,
    totalSuccessesPrevious: number,
    totalFailuresPrevious: number,
}

export interface BotStatsDataPoint {
    botId: number;
    bucketUtc: string;
    value: number;
    success: boolean;
}

export interface DynamicObject {
    [key: string]: any; // Allows any string key with any value type
}